// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  searchParams: {}, // 搜索传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  isShowSearch: false, //是否显示高级查询
  superClass: 0, //工具栏按钮
  selectedRowKeys: [], //选择的行
  tabList: [
    { name: '未冻结', num: '' },
    { name: '对账冻结', num: '' },
    { name: '付款冻结', num: '' },
  ],
  totalAmount: {},
};
export default modal;
